import { graphql } from "@opensea/graphql"
import {
  OpenTreasureChestModal_treasureFragment,
  OpenTreasureChestModalFragment,
} from "./OpenTreasureChestModal/OpenTreasureChestModal.fragment"

export const OpenChestButton_treasureFragment = graphql(
  `
    fragment OpenChestButton_treasure on Badge {
      name
      ...OpenTreasureChestModal_treasure
    }
  `,
  [OpenTreasureChestModal_treasureFragment],
)

export const OpenChestButtonFragment = graphql(
  `
    fragment OpenChestButton on TreasureChest {
      ...OpenTreasureChestModal
      isOpenable
      userProgress {
        totalPoints
      }
      userRewards {
        id
        claimedAt
      }
      userTokenRewards {
        id
        claimedAt
      }
      userTreasures {
        ...OpenChestButton_treasure
      }
    }
  `,
  [OpenTreasureChestModalFragment, OpenChestButton_treasureFragment],
)
